import { Mail, Phone, MapPin, Send } from 'lucide-react';
import toast from 'react-hot-toast';

const ContactUs = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
        toast.success("Message sent! We'll get back to you soon.");
        e.target.reset();
    };

    return (
        <div className="max-w-7xl mx-auto py-12 px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20">
                {/* Contact Info */}
                <div>
                    <h1 className="text-4xl md:text-5xl font-bold mb-6">Get in touch</h1>
                    <p className="text-xl text-zinc-500 mb-12">
                        We'd love to hear from you. Our friendly team is always here to chat.
                    </p>

                    <div className="space-y-8">
                        <div className="flex gap-4">
                            <div className="w-12 h-12 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-900 shrink-0">
                                <Mail size={24} />
                            </div>
                            <div>
                                <h3 className="font-bold text-lg mb-1">Chat to support</h3>
                                <p className="text-zinc-500 mb-1">We're here to help.</p>
                                <a href="mailto:support@versarc.com" className="font-bold text-blue-600 hover:underline">support@versarc.com</a>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="w-12 h-12 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-900 shrink-0">
                                <MapPin size={24} />
                            </div>
                            <div>
                                <h3 className="font-bold text-lg mb-1">Visit us</h3>
                                <p className="text-zinc-500 mb-1">Come say hello at our office HQ.</p>
                                <p className="font-bold text-zinc-900">123 Commerce St, Accra, Ghana</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="w-12 h-12 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-900 shrink-0">
                                <Phone size={24} />
                            </div>
                            <div>
                                <h3 className="font-bold text-lg mb-1">Call us</h3>
                                <p className="text-zinc-500 mb-1">Mon-Fri from 8am to 5pm.</p>
                                <a href="tel:+233240111100" className="font-bold text-blue-600 hover:underline">+233 24 011 1100</a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Form */}
                <div className="bg-white p-8 rounded-3xl border border-zinc-100 shadow-xl">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="grid grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-bold text-zinc-900 mb-2">First name</label>
                                <input type="text" className="w-full px-4 py-3 rounded-xl border border-zinc-200 outline-none focus:ring-2 focus:ring-zinc-900" placeholder="First name" required />
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-zinc-900 mb-2">Last name</label>
                                <input type="text" className="w-full px-4 py-3 rounded-xl border border-zinc-200 outline-none focus:ring-2 focus:ring-zinc-900" placeholder="Last name" required />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-zinc-900 mb-2">Email</label>
                            <input type="email" className="w-full px-4 py-3 rounded-xl border border-zinc-200 outline-none focus:ring-2 focus:ring-zinc-900" placeholder="you@company.com" required />
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-zinc-900 mb-2">Message</label>
                            <textarea rows="4" className="w-full px-4 py-3 rounded-xl border border-zinc-200 outline-none focus:ring-2 focus:ring-zinc-900" placeholder="Leave us a message..." required></textarea>
                        </div>

                        <button type="submit" className="w-full py-4 bg-zinc-900 text-white font-bold rounded-xl hover:bg-black transition-all flex items-center justify-center gap-2">
                            Send Message <Send size={18} />
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
